module.exports = __webpack_public_path__ + "img/TV_clean_box24.caadf404.jpg";